import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ConfigProvider } from 'antd';

import { App } from './app';

import { store } from './redux/store';
import { history } from './settings/history';
import { GlobalStyles } from './settings/themes/globalStyles';
import { defaultTheme } from './settings/themes/defaultTheme';
import { msalConfig } from './settings/azure/authConfig';

import './settings/i18n/i18n';
import { getAntdLocalesLanguage } from './utils/getAntdLocalesLanguage';
import reportWebVitals from './reportWebVitals';

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ConfigProvider locale={getAntdLocalesLanguage()}>
        <Provider store={store}>
          <HistoryRouter history={history}>
            <ThemeProvider theme={defaultTheme}>
              <App />
              <GlobalStyles />
            </ThemeProvider>
          </HistoryRouter>
        </Provider>
      </ConfigProvider>
    </MsalProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
